/* globals Intercom */

import autobind from 'class-autobind';

class IntercomTracker {

  constructor() {
    autobind(this);
  }

  trackEvent(event, eventMetadata) {
    if (typeof Intercom !== 'undefined') {
      Intercom('trackEvent', event, eventMetadata);
    }
  }

  trackCreatePrompt(promptId) {
    this.trackEvent('Created New Collector', {
      collector_id: promptId
    });
  }

  trackSendNewPromptCampaign(promptId) {
    this.trackEvent('Created/Sent New Collector Campaign', {
      collector_id: promptId
    });
  }

  trackSavedPromptIntroMessage(promptId) {
    this.trackEvent('Saved Intro Message', {
      collector_id: promptId
    });
  }
  
  trackAddedPromptQuestion(promptId) {
    this.trackEvent('Added Collector Question', {
      collector_id: promptId
    });
  }

  trackUploadedAssetToMediaLibrary(assetId, assetType) {
    this.trackEvent('Uploaded asset to media library', {
      asset_id: assetId,
      asset_type: assetType
    });
  }

  trackSendStatsAndAnalyticsReport(reportName) {
    this.trackEvent(`Downloaded ${reportName}`);
  }

  trackViewPageDetailsTab(pageId, tabName) {
    var tabDisplayName = tabName;
    if (tabName === 'permissions') {
      tabDisplayName = 'team permissions';
    } else if (tabName === 'privacy') {
      tabDisplayName = 'viewing privacy';
    }

    this.trackEvent(`Viewed Page Details "${tabDisplayName}" tab`, {
      page_id: pageId
    });
  }

  trackViewLinkDetailsTab(routeId, tabName) {
    this.trackEvent(`Viewed Link Details "${tabName}" tab`, {
      route_id: routeId
    });
  }

  trackPageEditorCopySection(pageId) {
    this.trackEvent('Use page editor copy section feature', { page_id: pageId });
  }

  trackPageEditorPasteSection(pageId) {
    this.trackEvent('Use page editor paste section feature', { page_id: pageId });
  }

  trackPageEditorDuplicateSection(pageId) {
    this.trackEvent('Use page editor duplicate section feature', { page_id: pageId });
  }

  trackPageEditorCopySubpage(pageId) {
    this.trackEvent('Use page editor copy subpage feature', { page_id: pageId });
  }

  trackPageEditorPasteSubpage(pageId) {
    this.trackEvent('Use page editor paste subpage feature', { page_id: pageId });
  }

  trackPageEditorDuplicateSubpage(pageId) {
    this.trackEvent('Use page editor duplicate subpage feature', { page_id: pageId });
  }

}

export default IntercomTracker;
